module.exports = __webpack_public_path__ + "static/media/Location_Pin.029b76e9.svg";